import React from 'react'
import { FormGroup, Typography, ControlFeedback } from '@smooth-ui/core-em'
import { Input, Button, Box, Space } from 'UILibrary'
import { updatePassword } from 'services/api'
import queryString from 'query-string'
import zxcvbn from 'zxcvbn'
import { validationMessage } from 'utils'
import Loader from '../../../components/Loader'
const fields = ['password', 'passwordConfirmation']

class ResetPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = fields.reduce((output, field) => ({ ...output, ...{ [field]: '' } }), { errors: {} })
  }

  onFormFieldChange = event => {
    const target = event.target
    const name = target.id
    const value = target.value

    this.setState(
      state => ({
        [name]: value,
        errors: { ...state.errors, [name]: this.validateField(name, value) },
      }),
      () => this.validatePasswordMatch(name, value)
    )
  }

  validatePasswordMatch = (name, value) => {
    const confirmPasswordValue = this.state.passwordConfirmation
    if (name === 'password' && confirmPasswordValue) {
      this.setState(state => ({
        errors: {
          ...state.errors,
          passwordConfirmation: value !== confirmPasswordValue ? "doesn't match" : '',
        },
      }))
    }
  }

  validateField = (name, value) => {
    if (!value) {
      return 'is missing'
    }

    switch (name) {
      case 'password': {
        let errorMessage = validationMessage(zxcvbn(value))
        if (8 > value.length) {
          return 'is too short'
        }
        if (errorMessage !== '') {
          return errorMessage
        }
        break
      }
      case 'passwordConfirmation': {
        if (value !== this.state.password) {
          return "doesn't match"
        }
        break
      }
      default:
        break
    }
  }

  isValid = () => fields.reduce((a, f) => a && this.state[f] && !this.state.errors[f], true)

  componentWillMount() {
    const query = queryString.parse(this.props.location.search)
    if (query.token) {
      this.setState({
        resetPasswordToken: query.token,
      })
    } else {
      this.props.showFlashMessage(true, 'There has been an unexpected error. Please try again. If the error persists, please contact help@dealvestors.com')
    }
  }

  handleRequestResetPassword = async event => {
    const { isLoadingStatus } = this.props
    event.preventDefault()

    if (!this.isValid()) return

    const submitData = {
      password: this.state.password,
      resetPasswordToken: this.state.resetPasswordToken,
    }
    isLoadingStatus(true)
    const { errors } = await updatePassword(submitData)
    errors && isLoadingStatus(false)
    if (0 < errors.length) {
      this.props.showFlashMessage(true, `${errors.join(';')}`)
    } else {
      this.props.history.push({ pathname: '/', search: `?token=${this.state.resetPasswordToken}` })
    }
  }

  render() {
    const { password, passwordConfirmation, errors } = this.state
    const { isLoading } = this.props
    return (
      <Box p={'m'}>
        <form onSubmit={this.handleRequestResetPassword}>
          <Typography variant="h3">Reset Password</Typography>
          <Space size="xl" />
          <FormGroup>
            <Input
              id="password"
              type="password"
              control
              placeholder="New Password"
              value={password}
              onChange={this.onFormFieldChange}
              valid={errors.password ? false : null}
            />
            {errors.password && <ControlFeedback valid={false}>{errors.password}</ControlFeedback>}
          </FormGroup>
          <FormGroup>
            <Input
              id="passwordConfirmation"
              type="password"
              control
              placeholder="Confirm Password"
              value={passwordConfirmation}
              onChange={this.onFormFieldChange}
              valid={errors.passwordConfirmation ? false : null}
            />
            {errors.passwordConfirmation && <ControlFeedback valid={false}>{errors.passwordConfirmation}</ControlFeedback>}
          </FormGroup>
          <Button form success onClick={this.handleRequestResetPassword} disabled={!this.isValid()}>
            {isLoading ? <Loader color="white" /> : 'RESET PASSWORD'}
          </Button>
        </form>
      </Box>
    )
  }
}

export default ResetPassword



// WEBPACK FOOTER //
// ./src/features/authentication/components/ResetPassword.js